<template>
  <div class="fw3">
    <div>
      <div class="f3">
        <span v-if="beer.brewery" class="fw7 pr1 dib">{{ breweriesMap[beer.brewery].name }}</span>
        <span class="nowrap">
          <span>{{ beer.name }}</span>
          <span v-if="beer.degrees">{{ beer.degrees }}°</span>
        </span>
      </div>

      <div v-if="beer.type" class="i lh-solid nowrap">
        {{ beerTypesMap[beer.type].name }}
        <span v-if="beer.alcohol">{{ beer.alcohol }}<smp-hair />%</span>
      </div>
    </div>

    <div
      v-if="beer.kegRemainingFraction"
      class="relative ph3 pv1 bg-black-10 mb2 mt1"
      title="hladina pivného sudu"
    >
      <div
        class="absolute left-0 top-0 h-100 pv1"
        :class="`bg-${ remainingColor }`"
        :style="{ width: `${ beer.kegRemainingFraction * 100 }%` }"
      ></div>

      <div
        v-if="remainingColor !== 'green'"
        :class="remainingColor"
        class="relative sans-serif tr f4 b lh-solid"
        style="text-shadow: -1px -1px 0 #e5e5e5, 1px -1px 0 #e5e5e5, -1px 1px 0 #e5e5e5, 1px 1px 0 #e5e5e5"
      >
        <template v-if="remainingColor === 'red'">zostáva menej než 10 pív!</template>
        <template v-if="remainingColor === 'orange'">zostáva menej než 20 pív!</template>
      </div>
    </div>

    <div class="tr">
      <span v-if="beer.price03">
        <span>0,3<smp-hair />l</span>
        <span class="price sans-serif b">{{ beer.price03 }}<smp-hair />&euro;</span>
      </span>

      <span v-if="beer.price04" class="ml4">
        <span>0,4<smp-hair />l</span>
        <span class="price sans-serif b">{{ beer.price04 }}<smp-hair />&euro;</span>
      </span>

      <span v-if="beer.price05">
        <span>0,5<smp-hair />l</span>
        <span class="price sans-serif b">{{ beer.price05 }}<smp-hair />&euro;</span>
      </span>
    </div>
  </div>
</template>

<script>
  import { arrayToMap } from '@/utils'

  export default {
    props: {
      beer: {
        required: true,
        type: Object,
      },
    },

    data () {
      return {
        breweriesMap: arrayToMap(__INITIAL_STATE__.breweries, '.key'),
        beerTypesMap: arrayToMap(__INITIAL_STATE__.beerTypes, '.key'),
      }
    },

    computed: {
      remainingColor () {
        if (this.beer.kegRemainingBeers <= 10) {
          return 'red'
        }

        if (this.beer.kegRemainingBeers <= 20) {
          return 'orange'
        }

        return 'green'
      },
    },
  }
</script>

<style scoped>
  .price {
    color: #fdc900;
  }
</style>



// WEBPACK FOOTER //
// src/components/BeerItem.vue?5231258e